import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=b0a8da12&scoped=true&"
import script from "./DoctorList.vue?vue&type=script&lang=js&"
export * from "./DoctorList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=b0a8da12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a8da12",
  null
  
)

export default component.exports